// src/components/Button/Button.jsx
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { NAMESPACE } from "../../namespace";
import "./Button.css";

class Button extends PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["submit", "button"]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    type: "button",
    className: "",
  };

  render() {
    const { className: customClassName, label, type, ...rest } = this.props;
    const className = `${NAMESPACE}Button ${customClassName}`.trim();
    return (
      <button type={type} className={`${className}`} {...rest}>
        <span>{label}</span>
      </button>
    );
  }
}

export default Button;
